<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M14.5 15L5.5 10L14.5 5" fill="#202830"/>
    </svg>
</template>

<script>
export default {
    name: 'IconLeftFill',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
